<div class="toast {{state}} {{config.type}}">
  <div class="message"
       [ngClass]="{'is-short': config.message?.length < 22}">{{config.message}}</div>
  <button class="ok-button"
          (click)="onClick()">OK
  </button>
</div>
